import { Action } from '@ngrx/store';
import { UrlParams } from './model/url-params.model';

export const PARAMS_CHANGED =  '[URL Params] Changed';

/**
 * Parser URL params are stored within store.
 */
export class ChangeUrlParamsAction implements Action {
    readonly type = PARAMS_CHANGED;

    constructor(public payload: UrlParams) { }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions = ChangeUrlParamsAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/url-params.actions.ts